import {
    MarkovStartvectorState,
    MarkovState,
} from "server/models"
import { OrderType } from "client/utils"
import { MarkovStateFilters } from "client/store"

export interface MarkovStartvectorStateProps {
    stateId: number
}

export interface MarkovStartvectorStateList { [stateId: number]: MarkovStartvectorState }
export interface MarkovStartvectorStateCalculated { [stateId: number]: number | string }

export type MarkovStartvectorStateValidation = { [key in keyof MarkovStartvectorState]?: string}

export interface MarkovStartvectorStateState {
    stateList: MarkovStartvectorStateList
    stateIds: readonly number[]
    stateEdit: MarkovStartvectorState

    calculatedExpressions: MarkovStartvectorStateCalculated

    sortColumn: keyof MarkovState
    sortOrder: OrderType
    filters: MarkovStateFilters

    reloadList: boolean
    reloadEdit: boolean
}

export const MARKOV_STARTVECTOR_STATE_LIST = "MARKOV_STARTVECTOR_STATE_LIST"
export const MARKOV_STARTVECTOR_STATE_IDS = "MARKOV_STARTVECTOR_STATE_IDS"
export const MARKOV_STARTVECTOR_STATE_EDIT = "MARKOV_STARTVECTOR_STATE_EDIT"

export const MARKOV_STARTVECTOR_STATE_CALCULATED_EXPRESSIONS = "MARKOV_STARTVECTOR_STATE_CALCULATED_EXPRESSIONS"

export const MARKOV_STARTVECTOR_STATE_SORT = "MARKOV_STARTVECTOR_STATE_SORT"
export const MARKOV_STARTVECTOR_STATE_FILTERS = "MARKOV_STARTVECTOR_STATE_FILTERS"

export const MARKOV_STARTVECTOR_STATE_RELOAD_LIST = "MARKOV_STARTVECTOR_STATE_RELOAD_LIST"
export const MARKOV_STARTVECTOR_STATE_RELOAD_EDIT = "MARKOV_STARTVECTOR_STATE_RELOAD_EDIT"
